import { Button, Card, Col, Row, Space, Statistic, Tooltip } from "antd"
import { useNavigate } from "react-router-dom";
import TableComponent from "../../components/TableComponent";
import { getCodes } from "../../store/slices/codeSlice";
import { getRoles } from "../../store/slices/roleSlice";
import { DollarOutlined, EyeOutlined } from "@ant-design/icons";
import { getTransactions } from "../../store/slices/transactionSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getDashboardData } from "../../store/slices/dashboardSlice";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, XAxis, YAxis } from "recharts";

const TransactionList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getDashboardData())
    }, [dispatch])
    const { dashboardData } = useSelector((state) => state?.dashboard)
    const dailyRevenue = dashboardData?.data?.dailyTransaction || []
    const columns = [
        {
            title: 'User Name',
            dataIndex: 'name',
            key: 'name',
            render : (_, data) => {
                return `${data?.user_id?.first_name} ${data?.user_id?.last_name}`
            }
        },
        {
            title: 'Invoice Number',
            dataIndex: 'invoice_number',
            key: 'invoice_number',
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        },
        // {
        //     title: 'Actions',
        //     key: 'actions',
        //     render: (_, data) => (
        //         <Space>
        //             <Button onClick={() => navigate('/role/edit/' + data?._id)} icon={<EyeOutlined />} size="small">Edit</Button>
        //             {/* <Button icon={<DeleteOutlined />} size="small" danger>Delete</Button> */}
        //         </Space>
        //     ),
        // }
    ];
    return (
        <div>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1>Transactions</h1>
            </div>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} lg={6}>
                    <Card title="Revenue">
                        <Statistic
                            value={dashboardData?.data?.revenue}
                            prefix={<DollarOutlined />}
                            precision={2}
                            valueStyle={{ color: '#cf1322' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                    <Card title="Total Transactions">
                        <Statistic
                            value={dashboardData?.data?.totalTransactions}
                            prefix={<DollarOutlined />}
                            valueStyle={{ color: '#cf1322' }}
                        />
                    </Card>
                </Col>
                {/* <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title="Daily Transaction"
                            value={dashboardData?.data?.dailyTransaction}
                            prefix={<DollarOutlined />}
                            valueStyle={{ color: '#cf1322' }}
                        />
                    </Card>
                </Col> */}
                <Col xs={24} sm={24} lg={12}>
                    <Card title="Daily Transactions">
                        {dailyRevenue.length > 0 ? (
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={dailyRevenue}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="_id" tickFormatter={(date) =>
                                    new Date(date).toLocaleDateString()
                                } />
                                <YAxis allowDecimals={false} />
                                <Tooltip formatter={(value) => `Rs ${value.toLocaleString()}`} />
                                <Bar dataKey="totalAmount" fill="#B49630" />
                            </BarChart>
                        </ResponsiveContainer>
                        ) : (
                            <p>No data available</p>
                        )}
                    </Card>
                </Col>
            </Row>
            <br/><br/>
            <TableComponent
                listData={getTransactions}
                columns={columns}
                placeholder="Search transactions..."
            />
        </div>
    )
}

export default TransactionList